import { Helmet } from 'react-helmet'
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import FALLBACK_OG_IMAGE from '../assets/images/oghome.png'

export default function Seo({ title, url, description, image, children }) {
  const data = useStaticQuery(graphql`
    query HeaderQuery {
      site {
        siteMetadata {
          title
          description
          author
          siteUrl
          domain
        }
      }
    }
  `)

  const {
    site: {
      siteMetadata: {
        title: DEFAULT_TITLE,
        description: DEFAULT_DESCRIPTION,
        author,
        siteUrl,
        domain,
      },
    },
  } = data

  const DOMAIN = domain
  const CODELABS = siteUrl

  //   const FALLBACK_OG_IMAGE = '/assets/images/oghome.png'

  const metaUrl = CODELABS + url
  const metaImage = DOMAIN + (image ?? FALLBACK_OG_IMAGE)
  const metaDescription = description || DEFAULT_DESCRIPTION
  const metaTitle = title || DEFAULT_TITLE

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link href={metaUrl} rel="canonical" />

      {/** OG */}
      <meta content="website" property="og:type" />
      <meta content={metaUrl} property="og:url" />
      <meta content={metaTitle} property="og:title" />
      <meta property="og:image" content={metaImage} />
      <meta content={metaDescription} property="og:description" />

      {/** Facebook */}
      <meta content={process.env.GATSBY_FB_APP_ID} property="fb:app_id" />

      {/** Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={author} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:url" content={metaUrl} />

      {children}
    </Helmet>
  )
}
